import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton.js";
import { BUTTON_TYPES } from "@/components_v2/Button/constants.js";

const { Title, Text } = Typography;

const ErrorBoundary = () => {
  const { t } = useTranslation();

  return (
    <div style={{ height: "70vh" }}>
      <div
        style={{
          position: "relative",
          top: "50%",
          transform: "translateY(-50%)",
          width: "60%",
          textAlign: "left",
          margin: "auto",
        }}
      >
        <Title level={4} style={{ marginTop: "18px" }}>
          {t("layouts.labels.errorBoundary.title")}
        </Title>
        <Text style={{ marginTop: "12px" }}>
          {t("layouts.labels.errorBoundary.message")}{" "}
          <strong>{t("layouts.labels.errorBoundary.supportEmail")}</strong>.
          {t("layouts.labels.errorBoundary.instruction")}
        </Text>
        <div style={{ textAlign: "center", marginTop: "15px" }}>
          <BaseButton to={-1} type={BUTTON_TYPES.LINK}>
            {t("layouts.labels.back")}
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
